import { FunctionComponent, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const Navbar1: FunctionComponent = () => {
  const navigate = useNavigate();

  const onLogoFrameContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onLogoFrameClick = useCallback(() => {
    // Please sync "store" to the project
  }, []);

  const onLogoFrameContainer1Click = useCallback(() => {
    navigate("/contact");
  }, [navigate]);

  return (
    <header className="self-stretch h-[125px] bg-black overflow-y-auto shrink-0 flex flex-row items-start justify-between gap-[20px] top-[0] z-[99] sticky max-w-full text-center text-5xl text-white font-racing-sans-one">
      <div className="h-[119px] w-[508px] flex flex-col items-start justify-between py-2.5 px-10 box-border max-w-full">
        <img
          className="w-[214px] h-[91px] relative object-cover"
          loading="eager"
          alt=""
          src="/bikelogo-1@2x.png"
        />
      </div>
      <div className="flex flex-row items-start justify-end py-[30px] px-5 box-border gap-[20px] max-w-full mq800:hidden">
        <div
          className="rounded-mini overflow-hidden flex flex-row items-center justify-center p-2.5 cursor-pointer"
          onClick={onLogoFrameContainerClick}
        >
          <div className="h-[30px] relative flex items-center justify-center">
            Home
          </div>
        </div>
        <button
          className="cursor-pointer py-2.5 px-[7px] bg-darkgray w-[82px] rounded-mini box-border flex flex-row items-center justify-center border-[3px] border-solid border-dimgray-200 hover:bg-dimgray-100 hover:box-border hover:border-[3px] hover:border-solid hover:border-gray-300"
          onClick={onLogoFrameClick}
        >
          <div className="h-[30px] relative text-5xl font-racing-sans-one text-white text-center flex items-center justify-center">
            Store
          </div>
        </button>
        <div
          className="flex flex-row items-center justify-center p-2.5 cursor-pointer"
          onClick={onLogoFrameContainer1Click}
        >
          <div className="h-[30px] relative flex items-center justify-center">
            Contact
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar1;
